/*
Ciencias Básicas y Matemática = 0
Ciencias de la Ingeniería Agroalimentaria = 1
Investigación = 2
Humanística y Estudios Complementarios = 3
*/

export const career_data = {
    name: "Ingeniería en Calidad e Innovación Agroalimentaria con grado en Bachillerato (BA-ICIAGRO)",
    code: "BA-ICIAGRO",
    mesh: {
        "0 0": {
            "#Ciencias Básicas y Matemática": ["Ciencias Básicas y Matemática", [], 0],
            "#Ciencias de la Ingeniería Agroalimentaria": ["Ciencias de la Ingeniería Agroalimentaria", [], 1],
            "#Investigación": ["Investigación", [], 2],
            "#Humanística y Estudios Complementarios": ["Humanística y Estudios Complementarios", [], 3]
        },
        "1 1": {
            "GEN1": ["Estudios Generales I", [], 3],
            "CAD400": ["Fundamentos del Desarrollo Agropecuario y Rural", [], 1],
            "QUD400": ["Química General para Ingeniería", [], 0],
            "MAT001": ["Matemática General", [], 0],
            "BIX101": ["Biología General", ["BIX101L"], 0],
            "BIX101L": ["Laboratorio Biología General", ["BIX101"], 0]
        },
        "1 2": {
            "GEN2": ["Estudios Generales II", [], 3],
            "GEN3": ["Estudios Generales III", [], 3],
            "LIX410": ["Inglés Integrado para otras Carreras I", [], 3],
            "MAT002": ["Cálculo", ["MAT001"], 0],
            "QUD402": ["Fundamentos de Química Analítica Cuantitativa", ["QUD400"], 0]
        },
        "2 1": {
            "LIX411": ["Inglés Integrado para otras Carreras II", ["LIX410"], 3],
            "QUX104": ["Química Biorgánica", ["QUD400", "BIX101", "QUX104L"], 0],
            "QUX104L": ["Laboratorio de Química Biorgánica", ["QUD400", "BIX101", "BIX101L", "QUX104"], 0],
            "FIY406": ["Fundamentos de Física", ["MAT002"], 0],
            "CAD401": ["Sistemas de Producción Agrícola", [], 1],
            "GEN4": ["Estudios Generales IV", [], 3]
        },
        "2 2": {
            "QUD406": ["Bioquímica para Ingeniería", ["QUX104", "QUX104L", "CAD404"], 0],
            "CAD402": ["Introducción a la Calidad", ["CAD404", "QUD406"], 1],
            "CAD403": ["Fisiología y Manejo Postcosecha", ["QUD406"], 1],
            "CAD404": ["Ingeniería de Alimentos", ["CAD404", "QUD406"], 1],
            "CAD405": ["Estadística Aplicada a la Calidad", ["MAT002"], 0],
            "CAD406": ["Sistemas de Producción Pecuaria", ["CAD400"], 1]
        },
        "3 1": {
            "CAD407": ["Gestión de la Innovación", [], 1],
            "CAD408": ["Microbiología e Inocuidad Agroalimentaria", ["CAD404"], 1],
            "CAD409": ["Calidad Nutricional y Normativa", ["CAD402"], 1],
            "CAD410": ["Ciencia y Tecnología de Productos Pecuarios", ["CAD404", "CAD406"], 1],
            "CAD411": ["Formulación y Evaluación de Proyectos", ["CAD405"], 2],
            "OPT1": ["Optativo I", [], 5]
        },
        "3 2": {
            "CAD412": ["Gestión y Aseguramiento de la Calidad Agroalimentaria", ["CAD402", "CAD414"], 1],
            "CAD413": ["Diagnóstico Fito, Zoosanitario y de Riesgos Microbiológicos", ["CAD408"], 1],
            "CAD414": ["Sistemas de Normalización, Acreditación y Certificación", ["CAD409", "CAD412"], 1],
            "CAD415": ["Ciencia Cognitiva y Sensorial de los Alimentos", ["CAD404"], 1],
            "CAD416": ["Diseño y Metodología de Investigación Científica", ["CAD411"], 2],
            "OPT2": ["Optativo II", [], 5]
        },
        "4 1": {
            "CAD417": ["Tecnologías de la Información Aplicadas a la Trazabilidad y Gestión de la Calidad", ["CAD412"], 1],
            "CAD418": ["Economía de la Calidad y Análisis de Mercados", ["CAD416"], 1],
            "CAD419": ["Ingeniería de la Agroindustria Tropical", ["CAD415"], 1],
            "CAD420": ["Sistemas de Diferenciación de la Calidad Agroalimentaria y Territorial", ["CAD417"], 1],
            "CAD421": ["Seminario de Diseño y Optimización de Productos", ["CAD418"], 2],
            "OPT3": ["Optativo III", [], 5]
        },
        "4 2": {
            "CAD422": ["Seminario de Emprendimiento e Innovación Agroalimentaria", ["CAD421"], 1],
            "CAD423": ["Productos Agroalimentarios y Culturas de Consumo", ["CAD420"], 1],
            "CAD424": ["Práctica Profesional Supervisada", [], 2],
            "OPT4": ["Optativo IV", [], 5]
        },
        "Opt": {
            "CAD430O": ["Propiedad Intelectual y Derecho Comercial", [], 1],
            "CAD431O": ["Teoría de la Organización de la Empresa", [], 1],
            "CAD432O": ["Logística y Cadenas de Distribución Alimentaria", [], 1],
            "CAD433O": ["Seminario de Oferta Agroalimentaria", [], 1],
            "CAD434O": ["Seguridad Industrial y Salud Ocupacional", [], 1],
            "CAD435O": ["Sistema de Producción Acuícola", [], 1],
            "CAD436O": ["Toxicología de Alimentos", [], 1],
            "CAD437O": ["Ciencia y Tecnología de la Nutrición Animal", [], 1],
            "CAD438O": ["Bioética Aplicada a la Calidad Agroalimentaria", [], 1],
            "CAD439O": ["Gestión Ambiental y Cambio Climático", [], 1]
        }
    }
};